export enum UserType {
    Employee = 7,
    CustomerEmployee = 8
}